import AppSerializer from 'serializers/app';

class RefundSerializer extends AppSerializer {
	constructor(store, props) {
		super(store, props);
	}

	get attrs() {
		return {}
	}

	get relationships() {
		return {
			charge: { serialize: 'id' },
		}
	}

}

export default RefundSerializer;